// src/utils/validators.ts
export const isColCellphone = (v: string) => {
    if (!v) {
        return true
    }
    const value = v.trim()

    // misma lógica que CreateAccount: si empieza con +57, validar +573#########
    if (value.startsWith('+57')) {
        return /^\+573\d{9}$/.test(value)
    }

    return true
}
